import useGetMe from '../api/queries/me/useGetMe';

export const useCompanyName = () => {
  const { data: me } = useGetMe();
  return me?.user.account.name;
};
